import React, { useState,useEffect } from 'react';
import './styles/department.css';
import axios from "axios";
import { Link } from 'react-router-dom';
import Navbar from './components/Navbar';
import { motion } from 'framer-motion';
import { FaSearch, FaInfoCircle, FaDownload } from 'react-icons/fa'; // Import the download icon
import Hero from './components/Hero';
import { useNavigate } from "react-router-dom";

function Department({ name }) {
    const [searchTerm, setSearchTerm] = useState('');
    const [qrCode, setQrCode] = useState('');

    useEffect(() => {
        const storedQrCode = localStorage.getItem('qrCode');
        if (storedQrCode) {
            setQrCode(storedQrCode);
        }
    }, []);

    const therapyAreas = [
        { name: "Metabolic disorders", icon: "./metabolism.png", link: "/metabolism", description: "Explore treatments for metabolic conditions" },
        
    ];

    const filteredTherapyAreas = therapyAreas.filter(area =>
        area.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
        area.description.toLowerCase().includes(searchTerm.toLowerCase())
    );
    

    const handleSearchChange = (event) => {
        setSearchTerm(event.target.value);
    };
    const navigate = useNavigate();

    const downloadQRCode = async () => {
        console.log(qrCode)
        console.log(localStorage.getItem("userName"))
        if(qrCode){
            const link = document.createElement('a');
            link.href = `data:image/png;base64,${qrCode}`;
            link.download = 'QRCode.png';
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);

        }
        const localStorageUsername = localStorage.getItem("doctorId")
        // 🔹 Update "downloaded" status in database
        const response = await axios.post(
            `https://testone.conversationaily.ai/api/diabetes/update_qrcode`,
            {
                userName:localStorageUsername
            }
          );
          
        // localStorage.setItem("downloaded", response.data.download);
        // Delay navigation by 2 seconds (2000ms)
        setTimeout(() => {
          navigate("/metabolism");
        }, 5000);
      };

    return (
      <div className="mx-auto">
            <Navbar name={name} />
            {qrCode && (
  <div className="relative mt-6 flex justify-center top-layer">
    <img 
      src={`data:image/png;base64,${qrCode}`} 
      alt="Login QR Code" 
      className="h-44 w-44 rounded-md shadow-sm ring-1 ring-inset ring-gray-900/10"
    />
  </div>
)}


            {/* <Hero /> */}
      <section id='therapy'>
      <div className="mx-auto max-w-7xl sm:px-6 lg:px-8 mt-6 py-6 px-4 justify-center" >
                <motion.h1 
                    initial={{ opacity: 0, y: -20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.5 }}
                    className="text-4l font-bold text-center text-orange-500 mb-8"
                >
                    This is your personalized QR code to obtain consent from your patients
                    <br/><br/>

{/* Download Button */}
<button
onClick={downloadQRCode}
className="bg-orange-500 text-white font-bold py-2 px-4 rounded-lg hover:bg-orange-600 transition duration-300"
>
Download QR Code
</button>
                </motion.h1>
 
            </div>
      </section>
          
        </div>
    );
}

export default Department;